import { useMemo } from "react";

import { usePrincipal } from "authentication/AuthProvider";

import useStorage, { StorageEntry } from "./useStorage";

export default function useOrganisationStorage(entry: StorageEntry) {
	const principal = usePrincipal();

	const key = useMemo(() => {
		if (!principal?.isFullyAuthenticated()) {
			throw new Error("Missing principal");
		}

		return `${principal.userId}.${principal.organisationId}.${entry.key}`;
	}, [principal?.userId, principal?.organisationId, entry.key]);

	return useStorage({ key });
}
